<template>
  <Layout>
    <div class="section content is-size-7 has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Contact') }}</h1>
      <span class="is-size-7">
        <p>
          Уколико имате било каквих питања можете нам послати е-пошту на <a class="has-text-primary" href="mailto:gamegame.rs@silverlines.info">gamegame.rs@silverlines.info</a> или нас позвати на <a class="has-text-primary" href="tel:0113216815">0113216815</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'

export default {
  name: 'Help',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangGG/RS/Contact.vue